import { AlternativeMedicineMain } from './AlternativeMedicineMain';
import { AlternativeMedicineProvider } from 'Context/AlternativeMedicine';

export const AlternativeMedicine = () => (
  <AlternativeMedicineProvider>
    <AlternativeMedicineMain />
  </AlternativeMedicineProvider>
);
